import I18N from '@leverege/i18n';
import TimelineView from "./TimelineView.js";
import TimelineModel from "./TimelineModel.js";
const TYPE = 'rsrc.dataViewer.TimelineDataViewer';
const {
  tf,
  tfIcon
} = I18N.ns(TYPE);
export default {
  id: TYPE,
  type: 'imagineRsrc.Timeline',
  name: tf('name', 'Timeline'),
  icon: tfIcon('icon', 'fa fa-clock fa-fw'),
  layout: {
    section: tf('section', 'Resources'),
    sort: tf('sort', 'resources.a')
  },
  location: ['main'],
  matches: {
    type: 'ItemInfoDataViewer'
  },
  component: TimelineView,
  createSettings: props => {
    return TimelineModel.create();
  }
};